<template>
  <div id="share">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GF分享模板</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="search()"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-notebook-2"
          @click="(createVisible = true), (establish = {})"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          @click="
            openAmendVisible(), (title = 'GF分享模板-修改'), (readonly = false)
          "
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          @click="openDelete()"
          >删除</el-button
        >

        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="
            openAmendVisible(), (title = 'GF分享模板-查看'), (readonly = true)
          "
          >查看</el-button
        >
      </div>
    </div>
    <!--创建弹窗  -->
    <div class="create">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="GF分享模板-创建"
        :visible.sync="createVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="100px"
          :model="establish"
          :rules="createdRules"
          ref="createRef"
        >
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="模板类型" prop="templateType">
                  <el-select
                    style="width: 100%"
                    v-model="establish.templateType"
                  >
                    <el-option
                      v-for="item in optionType"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分享模板编号" prop="templateNo">
                  <el-input v-model="establish.templateNo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="板块编号">
                  <el-select v-model="establish.plateNum" style="width: 100%">
                    <el-option
                      v-for="item in plateNum"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分享模板名称" prop="templateName">
                  <el-input v-model="establish.templateName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="是否启用">
                  <el-select style="width: 100%" v-model="establish.isActive">
                    <el-option
                      v-for="item in optionState"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
            </el-row>
          </div>
          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">封面信息</span>
          </div>
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="模板封面">
              <el-input v-model="establish.templateCoverUrl"></el-input>
            </el-form-item>
            <el-form-item label="图片">
              <el-image
                style="width: 100px; height: 100px"
                :src="establish.templateCoverUrl"
                :preview-src-list="[establish.templateCoverUrl]"
              ></el-image>
            </el-form-item>
          </div>
          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">详细信息</span>
          </div>
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="标题">
              <el-input v-model="establish.title"></el-input>
            </el-form-item>
            <el-form-item label="正文">
              <el-input v-model="establish.content"></el-input>
            </el-form-item>
            <el-form-item label="底部内容">
              <el-input v-model="establish.bottomTab"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="establishPreservation()">保 存</el-button>
          <el-button @click="(createVisible = false), (establish = {})"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!--修改、查看弹窗  -->
    <div class="amend">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        :title="title"
        :visible.sync="amendVisible"
      >
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="100px"
          :model="establish"
          :rules="createdRules"
          ref="createRef"
        >
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="模板类型" prop="templateType">
                  <el-select
                    style="width: 100%"
                    v-model="establish.templateType"
                    :disabled="readonly"
                  >
                    <el-option
                      v-for="item in optionType"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分享模板编号" prop="templateNo">
                  <el-input v-model="establish.templateNo" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="板块编号">
                  <el-select
                    v-model="establish.plateNum"
                    :disabled="readonly"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in plateNum"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分享模板名称" prop="templateName">
                  <el-input
                    v-model="establish.templateName"
                    :disabled="readonly"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="是否启用">
                  <el-select
                    style="width: 100%"
                    v-model="establish.isActive"
                    :disabled="readonly"
                  >
                    <el-option
                      v-for="item in optionState"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
            </el-row>
          </div>
          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">封面信息</span>
          </div>
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="模板封面">
              <el-input
                v-model="establish.templateCoverUrl"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
            <el-form-item label="图片">
              <el-image
                style="width: 100px; height: 100px"
                :src="establish.templateCoverUrl"
                :preview-src-list="[establish.templateCoverUrl]"
              ></el-image>
            </el-form-item>
          </div>
          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">详细信息</span>
          </div>
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="标题">
              <el-input
                v-model="establish.title"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
            <el-form-item label="正文">
              <el-input
                v-model="establish.content"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
            <el-form-item label="底部内容">
              <el-input
                v-model="establish.bottomTab"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="EditPreservation()" v-if="!readonly"
            >保 存</el-button
          >
          <el-button
            @click="
              (amendVisible = false),
                (templatei = {}),
                (establish = {}),
                (radioxz = '')
            "
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除模板确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>模板信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitDelete()">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
          size="small"
          :inline="true"
        >
          <el-form-item label="板块编号">
            <el-input v-model="queryInfo.plateNum"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="queryInfo.isActive">
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in optionState"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input v-model="queryInfo.templateName"></el-input>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-select style="width: 100%" v-model="queryInfo.templateType">
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in optionType"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="templateNo"
            label="分享模版编号"
          ></el-table-column>
          <el-table-column
            prop="templateName"
            label="分享模板名称"
          ></el-table-column>
          <el-table-column prop="isActive" label="是否启用">
            <template slot-scope="scope">{{
              scope.row.isActive == 1 ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column prop="templateType" label="模板类型">
            <template slot-scope="scope">{{
              scope.row.templateType == 1 ? "创建邀请函" : "模板库模板"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建日期" width="150">
            <template slot-scope="scope">{{
              scope.row.createTime | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后修改人"
          ></el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.updateTime">
                {{ scope.row.updateTime | dateFormat }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="table-button">
                
                <el-button
                  size="mini"
                  title="查看"
                  icon="iconfont icon-chakan1"
                  @click="
                    openAmendVisible(scope.row),
                      (title = 'GF分享模板-查看'),
                      (readonly = true)
                  "
                ></el-button>
                <el-button
                  size="mini"
                  title="修改"
                  icon="iconfont icon-xiugai1"
                  @click="
                    openAmendVisible(scope.row),
                      (title = 'GF分享模板-修改'),
                      (readonly = false)
                  "
                ></el-button>
                
                <el-button
                  size="mini"
                  title="删除"
                  icon="iconfont icon-a-shanchu11"
                  @click="openDelete(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>

        <el-alert
          v-if="total <= tableData.length"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import {
  getGFShareList,
  addShare,
  updateShare,
  deleteShare,
} from "@/api/friends";
export default {
  name: "centre",
  data() {
    return {
      loading: false,
      optionType: [
        {
          value: 0,
          label: "模板库模板",
        },
        {
          value: 1,
          label: "创建邀请函",
        },
      ], //模板类型
      // 是否启用
      optionState: [
        {
          value: false,
          label: "否",
        },
        {
          value: true,
          label: "是",
        },
      ],
      radioxz: "",
      deleteFormVisible: false,
      amendVisible: false,
      createVisible: false,
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      tableData: [],
      queryInfo: {
        pageNo: 1,
        pageSize: 20,
        isActive: null,
        plateNum: null,
        templateName: null,
        templateType: null,
      },
      establish: {
        bottomTab: undefined,
        content: undefined,
        cpyNO: getcpyNo(),
        isActive: undefined,
        plateNum: undefined,
        templateCoverUrl: undefined,
        templateName: undefined,
        templateNo: undefined,
        templateType: undefined,
        title: undefined,
      },
      plateNum: [
        {
          value: "T1",
          label: "T1",
        },
        {
          value: "T2",
          label: "T2",
        },
        {
          value: "T3",
          label: "T3",
        },
        {
          value: "T4",
          label: "T4",
        },

        {
          value: "T5",
          label: "T5",
        },
      ], //模板编号值
      total: 0, //总数
      size: 0, //当前页条数
      pageSize: 0,
      templatei: [],
      title: "", //修改、查看弹窗标题
      readonly: false, //是否只读
      // 创建form验证规则
      createdRules: {
        templateType: [
          { required: true, message: "请选择模板类型", trigger: "blur" },
        ],
        templateNo: [
          { required: true, message: "请输入模板编号", trigger: "blur" },
        ],
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
      },
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        delete: false,
        look: false,
      },
    };
  },
  created() {
    this.loading = true;
    this.tableList();
    let Share = JSON.parse(localStorage.getItem("Share"));

    for (let i = 0; i < Share.length; i++) {
      if (Share[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Share[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Share[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }

      if (Share[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }

      if (Share[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.tableList();
        }
      }, 1000);
    },
    //打开删除弹窗
    openDelete(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.templateNo) {
        this.deleteFormVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //删除模板信息
    submitDelete() {
      deleteShare({
        templateID: this.templatei.templateID,
      }).then((res) => {

        if ((res.message == "success")) {
          this.$message.success(res.message);
          this.deleteFormVisible = false;
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
          this.radioxz = "";
          this.templatei = {};
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //打开修改弹窗
    openAmendVisible(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.templateNo) {
        this.amendVisible = true;

        this.establish.bottomTab = this.templatei.bottomTab;
        this.establish.content = this.templatei.content;
        this.establish.cpyNO = getcpyNo();
        this.establish.isActive = this.templatei.isActive;
        this.establish.plateNum = this.templatei.plateNum;
        this.establish.templateCoverUrl = this.templatei.templateCoverUrl;
        this.establish.templateName = this.templatei.templateName;
        this.establish.templateNo = this.templatei.templateNo;
        this.establish.templateType = this.templatei.templateType;
        this.establish.title = this.templatei.title;
        this.establish.templateID = this.templatei.templateID;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //修改保存
    EditPreservation() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          this.templatei = {};
          this.radioxz = "";
          await updateShare(this.establish).then((res) => {
            if ((res.message == "success")) {
              this.$message.success(res.message);
              this.amendVisible = false;
              this.radioxz = "";
              this.templatei = {};
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.tableList();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    //创建模板保存
    establishPreservation() {
      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          await addShare(this.establish).then((res) => {

            if ((res.message == "success")) {
              this.$message.success(res.message);
              this.createVisible = false;
              this.radioxz = "";
              this.templatei = {};
              this.tableData = [];
              this.queryInfo.pageNo = 1;
              this.tableList();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    //查询
    search() {
      this.tableData = [];
      this.queryInfo.pageNo = 1;
      this.tableList();
    },
    // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
    getCurrentRow(row) {
      this.templatei = row;

    },
    async tableList() {
      this.loading = true;
      await getGFShareList(this.queryInfo).then((res) => {
        console.log(res);
        this.tableData = this.tableData.concat(res.data.list);
        this.pageNum = res.data.pageNum;
        this.pageSize = res.data.size;
        this.total = res.data.total;
        this.size = res.data.size;
        this.loading = false;
      });
    },

    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
#share {
}
.header {
  .header-text {
    width: 300px;
    height: 50px;
    // margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  height: 35px;
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }

  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
